<template>
    <div>
        <b-row>
            <b-col md="12" class="mb-3">
                <span class="feedbacks-tooltip">
                    Customer Feedbacks
                    <b-btn variant="ghost" v-b-popover.hover="'List of all customer feedback sent through your loyalty app'" title="">
                        <i class="ic-tooltip" id="customer"></i>
                    </b-btn>
                </span>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <b-input-group>
                    <b-input-group slot="append">
                        <i class="icon-calendar"></i>
                    </b-input-group>
                    <datepicker
                        :config="daterangeConfig"
                        v-model="selectedDateRange"
                    >
                    </datepicker>
                </b-input-group>
            </b-col>
            <b-col sm="6" md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                <div class="filter-wrapper">
                    <b-input-group prepend=" ">
                        <b-form-input placeholder="Search" v-model="filter.keyword"></b-form-input>
                        <b-dropdown text="Advanced" variant="primary" slot="append"  v-model="filter.field">
                            <template v-for="(field,index) in searchFields">
                                <b-dropdown-item @click="searchOption(field.key)" :key="index">
                                    {{ field.label }}
                                    <i v-if="filter.field == field.key" class="ml-1"> 
                                        <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                    </i>
                                </b-dropdown-item>
                            </template>
                        </b-dropdown>
                    </b-input-group>
                </div>
            </b-col>
            <b-col sm="5" md="6" class="text-left text-md-right">
                <b-button variant="primary btn-table-export" @click="exportFeedback">Export</b-button>
            </b-col>
        </b-row>
        <div class="mt-3">
            <div class="data-container">
                <b-table 
                    :items="list"
                    :fields="feedbacks_fields"
                    :current-page="page"
                    responsive>
                    <template slot="message" slot-scope="data">
                        {{ data.item.message | truncate(50) }}
                    </template>
                    <template slot="action" slot-scope="data">
                        <b-button
                            variant="ghost btn-table-reply"
                            @click="showDetail(data.item)">
                        </b-button>
                    </template>
                </b-table>
            </div>
            <div>
                <b-row>
                    <b-col>
                        <div class="mt-1">
                            <span class="pagination-indicator">{{ startList }}-{{ endList }} of {{ maxPage }} per page</span>
                            <b-pagination 
                                hide-goto-end-buttons 
                                align="left" 
                                size="md" 
                                :total-rows="maxPage * list.length"
                                :limit="3"
                                :per-page="list.length"
                                @change="paginate"
                                :value="page"
                                class="custom-pagination-arrow-only mb-0 ml-2">
                            </b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <feedback-reply-modal></feedback-reply-modal>
    </div>
</template>

<script>
import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";
import { mapState } from "vuex";
import FeedbackReplyModal from "./CustomerFeedbackReply.vue";

export default {
    name: "customer-topic",
    components: {
        "feedback-reply-modal": FeedbackReplyModal,
        Switches,
        Datepicker
    },
    data() {
        let self = this;
        
        return {
            selectedDateRange: "",
            timeout: 500,
            filter: {
                keyword: null,
                field: null,
                dateFrom: null,
                dateTo: null
            },
            searchFields: [
                {
                    key: "all",
                    label: "All"
                },
                {
                    key: "feedback_by",
                    label: "Full Name"
                },
                {
                    key: "topic",
                    label: "Topic Title"
                },
                {
                    key: "message",
                    label: "Feedback"
                }
            ],
            feedbacks_fields: [
                {
                    key: "feedback_by",
                    label: "Full Name",
                    sortable: true
                },
                {
                    key: "title",
                    label: "Topic Title",
                    sortable: true
                },
                {
                    key: "message",
                    label: "Feedback",
                    sortable: false
                },
                {
                    key: "date_created",
                    sortable: true
                },
                {
                    key: "action",
                    sortable: false,
                    variant: "action"
                }
            ],
            daterangeConfig: {
                altInput: true,
                altFormat: "M j, Y",
                dateFormat: "Y-m-d",
                static: true,
                mode: "range",
                defaultDate: ["today", "today"],
                onChange: function(selectedDates) {
                    if (selectedDates.length === 2) {
                        self.filter.dateFrom = self
                            .$moment(selectedDates[0])
                            .format("YYYY-MM-DD");
                        self.filter.dateTo = self
                            .$moment(selectedDates[1])
                            .format("YYYY-MM-DD");
                    }
                }
            }
        };
    },
    created: function() {
        this.$store.dispatch("feedbacks/getFirstPage");
    },
    computed: {
        ...mapState("feedbacks", [
            "uuid",
            "loading",
            "view",
            "list",
            "page",
            "perPage",
            "maxPage",
            "nextPage",
            "prevPage",
            "startList",
            "endList",
            "message",
            "topic",
            "errors",
        ]),
        ...mapState("analytics", ["isSegmentAnalyticsReady"]),
    },
    methods: {
        paginate(page) {
            this.$store.commit("feedbacks/setPage", page);
            this.$store.dispatch("feedbacks/getList");
        },
        searchOption(filter) {
            this.filter.field = this.filter.field == filter ? null : filter;
            this.doSearch();
        },
        doSearch: function() {
            let _this = this;

            setTimeout(function() {
                _this.$store.commit("feedbacks/setSearchDefault");
                _this.$store.commit("feedbacks/setSearchFilter", _this.filter);
                _this.$store.dispatch("feedbacks/getFirstPage");
            }, this.timeout);
        },
        showDetail: function(feedback) {
            let _this = this;

            this.$store.commit("feedbacks/setUuid", feedback.uuid);
            this.$store.commit("feedbacks/setReplyDefault");
            this.$store.dispatch("feedbacks/getFeedbackInfo").then(function() {
                if (_this.errors == null) {
                    _this.$root.$emit("bv::show::modal", "feedback-reply");
                }
            });
        },
        async exportFeedback() {
            this.$store.commit("feedbacks/setSearchDefault");
            this.$store.commit("feedbacks/setSearchFilter", this.filter);
            await this.$store.dispatch("feedbacks/exportFeedback");

            if (
                !this.errors &&
                this.isSegmentAnalyticsReady
            ) {
                window.analytics.track("Export Feedbacks", this.filter);
            }
        }
    },
    watch: {
        filter: {
            handler() {
                this.doSearch();
            },
            deep: true,
        },
    }
};
</script>
